import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { isValidPhoneNumber } from "react-phone-number-input";
import { parse } from "date-fns";

function isAdmin(type: any) {
  return type === "admin";
}

export function CreateUserValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    email: Yup.string()
      .email(t("LABEL.invalid email"))
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    phone: Yup.string()
      .optional()
      .test(
        "is-valid-phone",
        t("LABEL.invalid phone"),
        (value) => !value || isValidPhoneNumber(value)
      ),
    type: Yup.string()
      .required(t("LABEL.required"))
      .oneOf(["admin", "employ"], t("LABEL.invalid option")),
    address: Yup.string().optional(),
    payment: Yup.string().required(t("LABEL.required")),
    // treatment: Yup.string()
    //   .required(t("LABEL.required"))
    //   .oneOf(["Sir", "Madam", "Doctor"], t("LABEL.invalid option")),
    roles: Yup.string().when("type", {
      is: isAdmin,
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(t("LABEL.required")),
    }),
    crm: Yup.string().optional(),
    // .required(t("LABEL.required")),
    active: Yup.boolean().optional(),
    cpf: Yup.string().required(t("LABEL.required")),
    date: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .typeError(t("LABEL.invalid date"))
      .optional(),
    password: Yup.string()
      .min(6, t("LABEL.min 6"))

      .required(t("LABEL.required")),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), undefined], t("LABEL.confirm password"))
      .required(t("LABEL.required")),
  });

  return validation;
}

export function UpdateUserValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    email: Yup.string()
      .email(t("LABEL.invalid email"))
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    phone: Yup.string()
      .optional()
      .test("is-valid-phone", t("LABEL.invalid phone"), (value) => {
        if (!value) return true;
        return isValidPhoneNumber(value);
      }),
    address: Yup.string().optional(),
    payment: Yup.string().required(t("LABEL.required")),
    // treatment: Yup.string()
    //   .required(t("LABEL.required"))
    //   .oneOf(["Sir", "Madam", "Doctor"], t("LABEL.invalid option")),
    type: Yup.string()
      .required(t("LABEL.required"))
      .oneOf(["admin", "employ"], t("LABEL.invalid option")),
    roles: Yup.string().when("type", {
      is: isAdmin,
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(t("LABEL.required")),
    }),
    crm: Yup.string().optional(),
    // active: Yup.boolean().optional(),
    cpf: Yup.string()
      // .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })),
      .optional(),
    date: Yup.string()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .typeError(t("LABEL.invalid date"))
      .optional(),
    avatar: Yup.string().optional(),
  });

  return validation;
}
